// src/components/AdminSettings/tabs/AccountTab.tsx
import React from 'react';
import { pencil } from 'ionicons/icons';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { ClickableAvatar } from '../../ui/AvatarPicker';
import { TIMEZONE_OPTIONS } from '../../../types/user';
import type { AccountTabProps } from '../types';

export const AccountTab: React.FC<AccountTabProps> = ({
  user,
  userProfile,
  currentHousehold,
  onEditProfile,
  onEditAvatar,
  onSignOut,
}) => {
  return (
    <>
      <Card title="Your Profile" style={{ marginBottom: 16 }}>
        {/* Avatar and Name Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid var(--ion-border-color)',
        }}>
          {/* Clickable Avatar */}
          <ClickableAvatar
            avatarUrl={userProfile?.avatar_url}
            fallback={(userProfile?.full_name?.[0] || user?.email?.[0] || '?').toUpperCase()}
            size={72}
            onClick={onEditAvatar}
            showEditOverlay
          />
          {/* Name and Email */}
          <div style={{ flex: 1 }}>
            <div style={{
              fontFamily: 'var(--kff-heading-font)',
              fontSize: 18,
              fontWeight: 600,
              color: 'var(--ion-text-color)',
              marginBottom: 4,
            }}>
              {userProfile?.full_name || userProfile?.display_name || 'Not set'}
            </div>
            <div style={{
              fontFamily: 'var(--kff-data-font)',
              fontSize: 14,
              color: 'var(--ion-color-medium)',
            }}>
              {user?.email || 'No email'}
            </div>
            <div style={{
              fontFamily: 'var(--kff-data-font)',
              fontSize: 12,
              color: 'var(--kff-forge-gold)',
              marginTop: 4,
            }}>
              Tap photo to change
            </div>
          </div>
        </div>

        <div style={{ display: 'grid', gap: 16 }}>
          <div>
            <div className="info-label">Display Name</div>
            <div className="info-value">{userProfile?.display_name || 'Not set'}</div>
          </div>
          <div>
            <div className="info-label">Phone</div>
            <div className="info-value">{userProfile?.phone || 'Not set'}</div>
          </div>
          <div>
            <div className="info-label">Timezone</div>
            <div className="info-value">
              {TIMEZONE_OPTIONS.find(t => t.value === userProfile?.timezone)?.label || userProfile?.timezone || 'Not set'}
            </div>
          </div>
        </div>
        <Button
          fill="outline"
          expand="block"
          iconStart={pencil}
          onClick={onEditProfile}
          style={{ marginTop: 16 }}
        >
          Edit Profile
        </Button>
      </Card>

      <Card title="Household" style={{ marginBottom: 16 }}>
        <div style={{ display: 'grid', gap: 12 }}>
          <div>
            <div className="info-label">Name</div>
            <div className="info-value">{currentHousehold?.name || 'No household'}</div>
          </div>
          <div>
            <div className="info-label">Role</div>
            <div className="info-value" style={{ textTransform: 'capitalize' }}>
              {currentHousehold?.role || 'N/A'}
            </div>
          </div>
        </div>
      </Card>

      <Card title="Sign Out">
        <p style={{
          fontFamily: 'var(--kff-data-font)',
          fontSize: 14,
          color: 'var(--ion-color-medium)',
          marginBottom: 16,
        }}>
          Sign out of your account on this device.
        </p>
        <Button variant="danger" expand="block" onClick={onSignOut}>
          Sign Out
        </Button>
      </Card>
    </>
  );
};

export default AccountTab;
